import { render } from "./BottomMenu.vue?vue&type=template&id=35b392c6&scoped=true"
import script from "./BottomMenu.vue?vue&type=script&lang=js"
export * from "./BottomMenu.vue?vue&type=script&lang=js"

import "./BottomMenu.vue?vue&type=style&index=0&id=35b392c6&scoped=true&lang=css"

import exportComponent from "/Applications/Sites/mystudentvue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35b392c6"]])

export default __exports__